import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';
import { positionProps } from './Tabs';

type PositionProps = {
	position?: positionProps;
};

type ContainerButtonProps = {
	active?: boolean;
	hasIcon?: boolean;
} & PositionProps;

type TabButtonProps = {
	hasIcon?: boolean;
};

type TabNavProps = {
	$columns: number;
} & PositionProps;

type ContentHeight = {
	contentHeight?: string | undefined;
	width?: string | undefined;
	overflow?: string | undefined;
	contentPadding?: string;
};

const getSideComponent = (position?: positionProps) => {
	if (position === 'bottom' || position === 'right') {
		return 'flex-end';
	}

	return 'flex-start';
};

export const Container = styled.div<PositionProps>`
	display: grid;
	grid-template-columns: 1fr;
	width: 100%;
	margin: 0;
	padding: 0;
`;

export const TabNav = styled.ul<TabNavProps>`
	display: grid;
	grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
	justify-content: ${({ position }) => getSideComponent(position)};
	list-style-type: none;
	margin: 0;
	padding: 0;
	align-items: left;

	& li:first-child > div {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
	}

	& li:last-child > div {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
	}
`;

export const ContainerButton = styled.div<ContainerButtonProps>`
	position: relative;
	transition: all 0.2s ease-in-out;
	background-color: ${({ active }) =>
		active ? '#E8EFF7' : tokens.color_white};
	display: flex;
	padding: ${({ hasIcon }) => (hasIcon ? '0 30px' : 'unset')};
	border: 1px solid #6893ca;

	&:hover {
		background-color: ${({ active }) => (active ? '#1867c014' : '#f5f7fa6b')};
	}
`;

export const TabButton = styled.button<TabButtonProps>`
	background: transparent;
	border: none;
	height: 45px;
	color: #6893ca;
	font-size: 14px;
	font-weight: 600;
	padding: ${({ hasIcon }) => (!hasIcon ? '0 30px' : '0 10px')};
	cursor: pointer;
	width: 100%;
	text-align: center;
`;

export const Content = styled.div<ContentHeight>`
	padding: ${({ contentPadding }) => contentPadding ?? '20px'};
	background: ${tokens.color_white};
	height: ${({ contentHeight }) => contentHeight ?? '100%'};
	width: ${({ width }) => width ?? '100%'};
	overflow: ${({ overflow }) => overflow ?? 'hidden'};
`;

export const ContainerIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
